module.exports = __webpack_public_path__ + "f937551e2c294862ec7c9475c9370b38.svg";